import React from 'react';
import PropTypes from 'prop-types';

import Link from '@appComponents/Link';
import {ButtonAdd} from '@appComponents/ButtonCollection';
import {Authorization} from '@appComponents/Authorization';
import {authorizationObject} from '@modules/client/components/ApiKey/components/Table/authorizationObject';

const ApiKeyIndexButtons = ({id, openAVClientModal}) => {
    return (
        <div className='content__buttons'>
            <Authorization authorization={authorizationObject}>
                <Link name={'clients.apiKey.add'} params={{id}}>
                    <ButtonAdd onClick={openAVClientModal}>{'Generate new API key'}</ButtonAdd>
                </Link>
            </Authorization>
        </div>
    );
};

ApiKeyIndexButtons.propTypes = {
    id: PropTypes.number,
    openAVClientModal: PropTypes.func,
};

export default ApiKeyIndexButtons;
